// extracted by mini-css-extract-plugin
export var formContainer = "_gm-0";
export var message = "_gm-1";